var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('div',{staticClass:"search-box"},[_c('input',{ref:"autocomplete",staticClass:"form-control rounded",attrs:{"placeholder":"Search Hotel","onfocus":"value = ''","type":"text"}}),_c('i',{staticClass:"bx bx-search-alt search-icon text-secondary"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }